<template>
  <div :class="{ 'bank-connector-mobile': isMobile }">     
    <JobProgress v-model="asyncJobState" v-on:done="jobDone()" :job_id="asyncJobId">
        <template v-slot:progress>
            <v-progress-circular
                v-if="asyncJobState==='running'"
                indeterminate           
                color="primary"
                class="px-6"
            ></v-progress-circular>
        </template>
        <template v-slot:done>              
          <v-btn v-if="false"
            color="primary"
            @click="activateBankAccount()"
            :disabled="false">
            ACTIVAR BANCO
        </v-btn>
        </template>
    </JobProgress>
    <!-- <app-row>
      <app-col cols="12" class="btn-right">
      </app-col>
    </app-row> -->
    <app-row>
      <app-col cols="12">
        <v-card width="100%" class="rounded-10">
          <v-card-title class="primary--text text--darken-2 px-5 pb-0 d-flex card-title-footer-color">
            <v-row class="pa-0 ma-0">
              <v-col cols="3" class="pa-0 ma-0">
                <p class="primary--text">Bancos</p>
              </v-col>
              <v-col cols="9" class="pa-0 ma-0">
                  <slot name="search_right">

                    <div 
                        :class="['d-flex', 'justify-end', 'align-center', { 'toolbar-mobile-gap': isMobile }]"
                        align="right"
                        style="gap: 8px;"
                      >

                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn @click="mount_list" color="primary" icon v-bind="attrs" v-on="on" :loading="loading_ba">
                                    <v-icon>mdi-refresh</v-icon>
                                </v-btn>
                            </template>
                            <span>Actualizar</span>
                        </v-tooltip>

                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn @click="$router.push({name: 'create-bank-accounts'})" color="primary" icon v-bind="attrs" v-on="on">
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </template>
                            <span>Nueva cuenta bancaria</span>
                        </v-tooltip>

                        <v-tooltip top v-if="permission.can_write">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn 
                                @click="showDeletePupup = true" 
                                :disabled="!(selectedItems.length > 0)"
                                color="primary" 
                                icon 
                                v-bind="attrs" 
                                v-on="on">
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                            </template>
                            <span>Eliminar cuentas bancarias</span>
                        </v-tooltip>

                        <div v-if="permission.can_write">

                          <v-progress-circular
                              v-if="loadingActions"
                              indeterminate           
                              color="primary"
                          ></v-progress-circular>

                          <v-menu
                              v-else
                              offset-y
                              v-model="actionMenu"
                          >
                              <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                  :disabled="!(selectedItems.length > 0)"
                                  v-bind="attrs" 
                                  v-on="on"
                                  class="action__btn"
                                  :small="isMobile"
                                  style="min-height: 34px;"
                                  >
                                      ACCIONES 
                                      <v-icon v-if="actionMenu">mdi-menu-up</v-icon>
                                      <v-icon v-else>mdi-menu-down</v-icon>
                                  </v-btn>
                              </template>

                              <v-list>
                                  <v-list-item
                                      link
                                      @click="openDialogChangeCompany()"
                                  >
                                    <v-list-item-title>Cambiar empresa</v-list-item-title>
                                  </v-list-item>
                              </v-list>
                          </v-menu>

                        </div>

                        <v-btn v-if="got_feature('feature_can_use_payable_or_receivable_effects') && currentCompany"
                          color="primary"
                          outlined
                          :small="isMobile"
                          style="min-height: 34px;"
                          :href="'/'+ currentCompany.id + '/effects'">
                          <v-icon left>mdi-alpha-e-circle-outline</v-icon>
                          Efectos
                        </v-btn>
                        
                    </div>
                  </slot>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider />
          <v-card-text class="px-0 pt-0 card-title-footer-color">
            <span v-if="showSelect && !hideHeaderCheckbox">
                <v-checkbox
                    v-if="showSelectAll()"
                    class="ma-0 pt-5 pl-4"
                    v-model="selectAllItems"
                    :disabled="loadingItems"
                    @change="changeSelectAllItems"
                >
                <template v-slot:label>
                    <span class="text-field-size">Aplicar en los {{totalItems}} elementos</span>
                </template>
                </v-checkbox>
            </span>
            <v-data-table
              v-model="selectedItems"
              :items="bank_accounts"
              :footer-items-per-page-text="footerItemsPerPageText"
              :footer-items-per-page-options="footerItemsPerPageOptions"
              :headers="bank_accounts_headers"
              :show-select="showSelect"
              :loading="loadingItems"
              :server-items-length="totalItems"
              :page.sync="currentPage"
              :footer-props="{
                  'items-per-page-text': this.footerItemsPerPageText,
                  'items-per-page-options': this.footerItemsPerPageOptions,
              }"
              :no-data-text="textNoResults"
              :loading-text="textLoading"
              :class="className"
              @update:items-per-page="changeLimit"
              @update:page="changeOffset"
              @update:sort-by="sortTable"
              @update:sort-desc="sortTableDesc"
              @toggle-select-all=""
              fixed-header
              :item-key="itemKey"
              :mobile="mobile"
              >
              <!-- Columnas Personalizables -->
              <template v-for="header in bank_accounts_headers" v-slot:[`item.${header.value}`]="{ item }">
                <span class="font-color" v-if="!item.provider_information.link|| item.provider_information.link === ''">
                  <slot v-if="header.value == 'cuenta_bancos'" :name="header.value" v-bind="item">
                    <DocTextField
                        :readonly="!permission.can_write"
                        label=""
                        :kind="'account_am'"
                        v-model="editedBankAccounts[item.id]"
                        :items="accounts"
                        @get-values="getValues"
	                      @reset-items="resetItems"
                        @input="updateEditedPartidasAbiertas(item.id, editedPartidasAbiertas[item.id])"
                    ></DocTextField>
                    
                  </slot>
                  <slot v-else-if="header.value == 'cuenta_partidas_abiertas'" :name="header.value" v-bind="item">
                    <DocTextField
                        :readonly="!permission.can_write"
                        label=""
                        :kind="'account_am'"
                        v-model="editedPartidasAbiertas[item.id]"
                        :items="accounts"
                        @get-values="getValues"
	                      @reset-items="resetItems"
                        @input="updateEditedPartidasAbiertas(item.id, editedPartidasAbiertas[item.id])"
                    ></DocTextField>
                  </slot>
                  <slot v-else-if="header.value == 'ownerName'" :name="header.value" v-bind="item">
                    <DocTextField
                      class="no-underline"
                      :readonly="!permission.can_write"
                      label=""                      
                      v-model="item.ownerName"                      
                      @input="updateOwnerName(item.id)"
                    ></DocTextField>
                  </slot>
                  <slot v-else-if="header.value == 'kind'" :name="header.value" v-bind="item">
                    <span v-if="item[header.value] == 'manual'">Manual</span>
                    <span v-else-if="item[header.value] == 'afterbanks'">Automático (Avanzado)</span>
                    <span v-else-if="item[header.value] == 'gocardless'">Automático (PSD2)</span>
                  </slot>
                  <slot v-else :name="header.value" v-bind="item">{{ item[header.value] }}</slot>
                </span>
                
                <span v-else>
                  <a v-if="header.value == 'iban'" :href="item.provider_information.link">{{item.provider_information.link}}</a>
                </span>
              </template>
              <template v-if="hideHeaderCheckbox" #header.data-table-select></template>
                <!-- Header Personalizables -->
              <template v-for="header in bank_accounts_headers" v-slot:[`header.${header.value}`]="{ header }">
                  <v-checkbox
                      v-if="header.checkbox"
                      class="ma-0 pa-0"
                      @change="changeColSelected(header)"
                      :value="header.selected"
                      hide-details
                  >
                      <template v-slot:label>
                          <span>{{ header.text }}</span>
                      </template>
                  </v-checkbox>
                  <span v-else tabindex="0">
                      {{ header.text }}
                  </span>
              </template>
              <template v-slot:item.actions="{ item }">
                  <v-tooltip top v-if=" (item.kind !='manual' && item.provider_information.link && item.provider_information.link!== '')">
                      <template v-slot:activator="{ on, attrs }">
                          <v-btn @click="updateInformation(item)" v-bind="attrs" v-on="on" color="primary" icon :loading="isLoading(item.id, 'update-info')">
                              <v-icon>mdi-refresh</v-icon>
                          </v-btn>
                      </template>
                      <span>Actualizar información</span>
                  </v-tooltip>
                  <v-tooltip top v-if="!item.provider_information.link|| item.provider_information.link === ''">
                      <template v-slot:activator="{ on, attrs }">
                          <v-btn @click="$router.push({name: 'bank-transactions',params: {'company_id': currentCompany.id, 'bank_account_id': item['id']}})" v-bind="attrs" v-on="on" color="primary" icon :loading="isLoading(item.id, 'get-transactions')">
                              <v-icon>mdi-cash-sync</v-icon>
                          </v-btn>
                      </template>
                      <span>Consultar movimientos</span>
                  </v-tooltip>
                  
                  <v-tooltip top v-if="(!item.provider_information.link || item.provider_information.link === '') && permission.can_write">
                      <template v-slot:activator="{ on, attrs }">
                          <v-btn 
                            @click="UpdateBankAccount(item)" 
                            v-bind="attrs" 
                            v-on="on" 
                            color="primary" 
                            icon 
                            :loading="isLoading(item.id, 'save-bank-account')"
                            :disabled="!isDirty(item.id, 'save-bank-account')"
                            >
                            <v-icon>mdi-content-save</v-icon>
                          </v-btn>
                      </template>
                      <span>Guardar</span>
                  </v-tooltip>
              </template>
              <!--Footer: Paginación-->
              <template v-slot:[`footer.page-text`]="items">
                  {{ items.pageStart }} - {{ items.pageStop }} de {{ items.itemsLength }}
              </template>
            </v-data-table>
          </v-card-text>

          <v-dialog v-model="dialogChangeCompanies" persistent max-width="500">
            <v-card>
              <v-card-title class="headline">
                <span class="text-h5 primary--text py-1 ml-2">Traspaso de bancos</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <app-select
                  :items="availableCompanies"
                  :itemText="'name'"
                  :itemValue="'id'"
                  v-model="selectedCompany"
                  :hideDetails="true"
                  :label="'Empresa'"
                >
                </app-select>
              </v-card-text>
              <v-card-actions class="mr-4">
                <v-spacer></v-spacer>
                <app-btn outlined @click="dialogChangeCompanies=false; loadingActions=false">Cancelar</app-btn>
                <app-btn class="btn-accept" color="primary" variant="text" @click="changeCompanyBankAccount()" :disabled="!selectedCompany">Confirmar</app-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          

          <app-confirm-modal
            v-model="showDeletePupup"
            :text-msg="msgDeletePupup"
            :loading="loading_d_ba"
            @confirm="deleteBankAccounts()"
            @cancel="showDeletePupup = false"
          >
          </app-confirm-modal>

          <app-confirm-modal
            v-model="show_update_error"
            :text-msg="'Ha habido un error al intentar actualizar la cuenta. Por favor, inténtelo de nuevo más tarde.'"
            @confirm="show_update_error = false"
            :textConfirmButton="'Aceptar'"
            :showTextQuestion="false"
            :showCancelButton="false"
          >
          </app-confirm-modal>         

          
        </v-card>
      </app-col>
    </app-row>
  </div>
  
</template>

<script>
import AppBtn from "@/components/layout/AppBtn.vue";
import AppRow from "@/components/layout/AppRow.vue";
import AppCol from "@/components/layout/AppCol.vue";
import { query_dispatcher, sync_command_dispatcher, async_command_dispatcher} from "@/api/client";
import { CompanyBankAccounts } from "@/modules/bank/application/CompanyBankAccounts";
import { MountBankAccountList } from "@/modules/bank/application/MountBankAccountList";
import { UpdateBankAccountInformation } from "@/modules/bank/application/UpdateBankAccountInformation";
import { DeleteBankAccount } from "@/modules/bank/application/DeleteBankAccount";
import { UpdateBankAccountCommand } from "@/modules/bank/application/UpdateBankAccountCommand";
import DataTableWithApi from '../components/DataTableWithApi.vue';
import MessagePopup from '@/components/MessagePopup.vue';
import AppConfirmModal from '@/components/layout/AppConfirmModal.vue'
import AppTextField from '@/components/layout/AppTextField.vue';
import { GetCompanyQuery } from "@/modules/invoices/app/GetCompanyQuery";
import { ActivateBankAccountCommand } from "@/modules/bank/application/ActivateBankAccountCommand";
import JobProgress from '../components/JobProgress.vue';
import { mapState } from "vuex";
import { jobs } from '../api/jobs.js';
import { mapGetters, mapActions } from "vuex";
import { mapFields } from 'vuex-map-fields';
import DocTextField from "./DocTextField.vue"
import BankAccountDetail from '@/components/BankAccountDetail.vue';
import AppSelect from '@/components/layout/AppSelect.vue';
import { ChangeBankCompanyCommand } from "@/modules/bank/application/ChangeBankCompany"
import { isMobile } from "filestack-js";


export default {
  name: "BankConnector",
  components: {
    AppTextField,
    AppBtn,
    AppCol,
    AppRow,
    CompanyBankAccounts,
    DataTableWithApi,
    MessagePopup,
    AppConfirmModal,
    JobProgress,    
    DocTextField,
    BankAccountDetail,
    AppSelect
  },
  data() {
    return {
      
      companyBankAccounts: undefined,
      totalItems: 0,
      loading_ba: false,
      loadingStates: new Map(),
      loading_transactions:{},
      dirtyStates: new Map(),
      bank_accounts: [],
      bank_accounts_headers: [
        {
          text: 'IBAN',
          sortable: false,
          value:'iban'
        },
        {
          text: 'Nombre',
          sortable: false,
          value: 'ownerName'
        },
        {
          text: 'Cuenta de bancos',
          sortable: false,
          value: 'cuenta_bancos'
        },
        {
          text: 'Cuenta de partidas abiertas',
          sortable: false,
          value: 'cuenta_partidas_abiertas'
        },
        {
          text: 'Institución',
          sortable: false,
          value: 'institution'
        }, 
        {
          text: 'País',
          sortable: false,
          value: 'country' 
        },
        {
          text: 'Tipo',
          sorted: false,
          value: 'kind'
        },
        {
          text: '',
          align: 'end',
          sortable: false,
          value: 'actions',
        }
      ],
      country: '',
      country_list: ['Spain'],
      redirect_url: '',
      selectedItems: [],
      limit: 10,
      offset: 0,
      currentPage: 1,
      search: '',
      loadingItems: false,
      selectAllItems: false,
      tableHeight: '59vh',
      initNumItemsPerPage: 0,
      sortBy: '',
      footerItemsPerPageText: 'Registros por página:',
      footerItemsPerPageOptions: [5, 10, 50, 100],
      showSelect: false,
      textNoResults: 'No se han encontrado registros',
      textLoading: 'Cargando...',
      itemKey: 'id',
      hideHeaderCheckbox: false,
      className: '',
      mobile: false,
      dialog_upload_excel: false,
      currentItem: undefined,
      cuentaBancaria: '',
      idCuentaBancaria: '',
      showDeletePupup: false,
      msgDeletePupup: 'Se van a borrar las cuentas bancarias seleccionadas de la empresa.',
      loading_d_ba: false,
      editedBankAccounts:{},
      editedPartidasAbiertas:{},
      actual_company:undefined,
      asyncJobState: 'done',
      asyncJobId: 0,
      show_update_error:false,
      dialogChangeCompanies: false,
      availableCompanies: [],
      selectedCompany:null,
      actionMenu: false,
      loadingActions: false
    };
  },
  props: {
    third: {
      type: String,
      required: false,
    },
    company_id: {
      type: [String, Number],
      required: true
    },
  },
  watch: { 
    company_id: function() {
      this.mount_list()
    }
  },
  computed: {
        ...mapGetters({
            userData: 'me/userData',
            permission: 'permissions/permission',
            got_feature:'got_feature',
            isMobile: 'is_mobile'
        }),        
        ...mapState(['currentCompany']),
        ...mapFields('dialog_bank_rules', ['show_bank_rules_modal']),
        ...mapFields('cru', ['accounts']),
    },
  methods: {
    ...mapActions("cru", ['getAccounts']),    
    getValues(params) {
      this.getAccounts(params).then(() => {});
    },
    resetItems(params) {
      this.accounts = params;
    },
    changeFormat(dateString){
      const dateObject = new Date(dateString);
      const year = dateObject.getFullYear();
      const month = String(dateObject.getMonth() + 1).padStart(2, '0');
      const day = String(dateObject.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    loading_bank_accounts(value){
      this.loading_ba = value
    },
    async mount_list(){
      try {
        await new MountBankAccountList(query_dispatcher, this).run(this.company_id, this.limit, this.offset)
      } catch (error) {
        console.error('Error get bank account list', error)
      }
    },
    async getBankAccounts() {
      this.loadingItems = true;
      try {
        await this.companyBankAccounts.run(this.company_id, this.limit, this.offset)
        this.selectedItems = []
        //this.totalItems = this.bank_accounts.length
        if(this.totalItems > 0)
          this.showSelect = true
        this.selectAllItems = false;
        this.calculateTableHeight();
        this.loadingItems = false;
        this.bank_accounts.forEach(item => {
          this.$set(this.editedBankAccounts, item.id, item.cuenta_bancos || '');
          this.dirtyStates.set(`${item.id}-save-bank-account`, false);
        });
        this.bank_accounts.forEach(item => {
          this.$set(this.editedPartidasAbiertas, item.id, item.cuenta_partidas_abiertas || '');
        });
      } catch (error) {
        console.error('Error get bank accounts', error);
      }
      
    },
    isLoading(itemId, action) {
      const loadingKey = `${itemId}-${action}`;
      return this.loadingStates.get(loadingKey) || false;
    },
    change_loading_update_info(id, value){
      this.loadingStates.set(`${id}-update-info`, value);
    },
    async updateInformation(item){
      try {
        this.loadingInfo = true
        await new UpdateBankAccountInformation(sync_command_dispatcher, query_dispatcher, this).run(item.id)
        await this.getBankAccounts()
      } catch (error) {
        console.error('Error get bank account updated info', error)
      } finally {
        this.loadingInfo = false
      }
    },
    change_loading_get_transactions(id, value){
      this.loadingStates.set(`${id}-get-transactions`, value);
    },
    loading_delete_bank_accounts(value) {
      this.loading_d_ba = value
    },
    async deleteBankAccounts() {
      let del_ba = []
      for(let i in this.selectedItems)
        del_ba.push(this.selectedItems[i].id)
      try {
        await new DeleteBankAccount(sync_command_dispatcher, this).run(del_ba)
      } catch(error) {
        console.error('Error delete bank accounts:', error);
      }
      this.showDeletePupup = false
      this.mount_list()
    },
    showSelectAll() {
      let length_items = this.bank_accounts.length;
      let length_selected = this.selectedItems.length;
      if (length_items == length_selected && length_items != 0) {
          return true;
      }
      return false;
    },
    changeSelectAllItems(){
      if(this.selectAllItems) {
        this.selectedItems = []
        for(let i in this.bank_accounts){
          this.selectedItems.push(this.bank_accounts[i])
        }
      }
    },
    changeOffset(value) {
      this.offset = this.limit*(value-1);
      this.mount_list()
    },
    changeLimit(value) {
      if (value == -1) { //Option "All"
          value = 100000;
      }
      this.limit = value;
      this.mount_list()
    },
    sortTable(params) {
      this.sortBy = "";
      if (params && params[0]) {
          this.sortBy = params[0];
          this.mount_list()
      }
    },
    sortTableDesc(params) {
      if (params && params[0] && this.sortBy) {
          this.sortBy = '-' + this.sortBy;
          this.mount_list()
      }
    },
    calculateTableHeight() {
      this.initNumItemsPerPage = Math.min(this.limit, 5);
      if (this.totalItems == 0) {
        this.tableHeight = '20vh';
      }
      else {
        this.tableHeight = 48 * (Math.min(this.totalItems, this.initNumItemsPerPage) + 1).toString() + 'px';
      }
    },
    isDirty(itemId, action) {
      const dirtyKey = `${itemId}-${action}`;
      return this.dirtyStates.get(dirtyKey) || false;
    },
    change_loading_update_bank_account(id, value){
      this.loadingStates.set(`${id}-save-bank-account`, value);
    },
    
    async UpdateBankAccount(item){
      const cuenta_bancos = this.editedBankAccounts[item.id]
      const cuenta_partidas_abiertas = this.editedPartidasAbiertas[item.id]
      try {
        await new UpdateBankAccountCommand(sync_command_dispatcher, this).run(item.id, cuenta_bancos, cuenta_partidas_abiertas, item.ownerName)
        this.getBankAccounts()
      } catch (error) {
        console.error('Error while update bank account', error)
      }
      this.dirtyStates.set(`${item.id}-save-bank-account`, false);
    },
    updateEditedBankAccount(itemId, editedValue) {
      this.$set(this.editedBankAccounts, itemId, editedValue);
      this.dirtyStates.set(`${itemId}-save-bank-account`, true);
    },
    updateEditedPartidasAbiertas(itemId, editedValue) {
      this.$set(this.editedPartidasAbiertas, itemId, editedValue);
      this.dirtyStates.set(`${itemId}-save-bank-account`, true);
    },
    updateOwnerName(itemId) {      
      this.dirtyStates.set(`${itemId}-save-bank-account`, true);
    },
    async activateBankAccount(){
      try {
        await new ActivateBankAccountCommand(async_command_dispatcher, this).run(this.company_id, this.userData.user)
      } catch (error) {
        console.error('Error activate bank account', error)
      }
    },
    async jobDone(){
      const response = await jobs.getJob({ id: this.asyncJobId });
      this.asyncJobState = response.data.state;
      if (this.asyncJobState == 'done'){
        try {
          await new GetCompanyQuery(query_dispatcher, this).run(this.company_id)
        } catch(error) {
          console.error('Error get actual companydb', error)
        }
      }
    },
    isActivated() {
      if (this.actual_company && this.actual_company.id_company_reconciliation)
        return true
      return false
    },
    openDialogChangeCompany() {
      this.dialogChangeCompanies=true;
      this.loadingActions=true;
      this.actionMenu=false;
    },
    async changeCompanyBankAccount() {
      let del_ba = []
      for(let i in this.selectedItems)
        del_ba.push(this.selectedItems[i].id)
      try {
        await new ChangeBankCompanyCommand(sync_command_dispatcher, this).run(del_ba, this.selectedCompany)
        this.mount_list()
      } catch (error) {
        console.error('Error change company bank account', error)
      }
    },
  },
  async mounted() {
    try {
      await new GetCompanyQuery(query_dispatcher, this).run(this.company_id)
    } catch(error) {
      console.error('Error get actual companydb', error)
    }
    this.companyBankAccounts = new CompanyBankAccounts(query_dispatcher, this)
    this.mount_list()
    const urlParams = new URLSearchParams(window.location.search);
    if(urlParams.has('ba_id')){
      try {
        let cmd = new UpdateBankAccountInformation(sync_command_dispatcher, query_dispatcher, this)
        if (urlParams.has('code')){
          await cmd.run(urlParams.get('ba_id'), urlParams.get('code'))
        } else {
          await cmd.run(urlParams.get('ba_id'))
        }
        await this.mount_list()
      } catch (error) {
        console.error('Error get bank account updated info', error)
      }
      this.$router.push({name: 'bank-accounts',params: {'company_id': this.company_id}})
    }
  },

};
</script>
<style scoped>

  /*.card-title-footer-color {
      background: #FAFAFF;
  }
  ::v-deep .v-data-footer {
      background-color: #FAFAFF;
      margin-right: 0px !important;
      padding-right:  17px;
  }*/
  ::v-deep .v-data-table-header > tr > th{
      background-color: var(--v-primaryLight-base) !important;
  }
  ::v-deep .v-data-table-header > tr > th > span,
  ::v-deep .v-data-table-header > tr > th >  div > div > div > label > span{
      color: var(--v-primary-base);
      font-size: 0.875rem;
  }
  .font-color {
      color: #56565B;
  }

  ::v-deep .v-data-table__wrapper > table > tbody > tr > td {
      border-bottom: none !important;
  }

  ::v-deep tbody tr:nth-of-type(even) {
      /* 'deep-orange lighten-5' basides on material design color */
      background-color: rgba(245, 245, 245, 0.47);
  }

  ::v-deep .v-input__prepend-inner > div > i {
      color: var(--v-primary-base);
      top: 2px;
      padding-left: 5px;
  }

  .text-field-size {
      font-weight: normal;
      font-size: 0.875rem;
  }
  ::v-deep .input-search .v-input__slot::before {
        border-style: none !important;
  }

  ::v-deep .input-search .v-text-field__slot,
  ::v-deep .input-search .v-input__prepend-inner,
  ::v-deep .input-search .v-input__slot {
      background-color: #F2F1FF !important;
  }

  ::v-card-title .title-dialog {
    justify-content: space-around
  }

  .autocomplete_field {
    border: solid 1px;
    border-color: var(--v-primary-base);
    color: transparent !important; 
    height: 50px !important;
    margin: 0;
    padding: 0;
  }

  .acction_btns {
    display: flex !important;
    justify-content: space-between !important;
    padding: 0 36px 20px;
  }
  .cancel_button {
    border:  1px solid var(--v-primary-base);
    background-color: white !important;
    color: var(--v-primary-base);
    padding: 20px !important;
    font-size: 20px;
    text-transform: none !important;
  }

  .accept_button {
    border:  1px solid var(--v-primary-base);
    background-color: var(--v-primary-base) !important;
    color: white;
    padding: 20px !important;
    font-size: 20px;
    text-transform: none !important;
  }

  .btn-right {
    display: flex;
    justify-content: flex-end;
  }
 
 .no-underline >>> .v-text-field .v-input__control > .v-input__slot:before {
  border: none;
 }
 .rounded-10 {
  border-radius:10px !important;
 }

 .action__btn {
      border: 1px solid var(--v-primary-base) ;
      color: var(--v-primary-base);
      background-color: #FFFFFF !important;
  }
  .theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
      background-color: #FFFFFF !important;
  }
  .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover {
      color: var(--v-primary-base) !important;
      background: rgb(102, 51, 153, 0.1) !important;
  }

  .btn-accept {
    border: 1px solid var(--v-primary-base) !important;
  }
</style>

<!-- Mobile BankConnector -->
<style>
.bank-connector-mobile{
  .v-card__title {
    
    .row {
      display: block;

      .col-3 {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: center;
        align-items: center;

        p {
          margin-bottom: 0 !important;
        }
      }

      .col-9 {
        max-width: 100%;
        padding: 5px 0 !important;
        display: flex !important;
        flex-direction: row !important;
        flex-wrap: nowrap !important;
        align-content: center !important;
        justify-content: space-around !important;
        align-items: center !important;
      }
    }

    .toolbar-mobile-gap {
      gap: 2px !important; 
    }
  }
}
</style>
